import styles from "./Skeleton.module.css";

export function Skeleton({ lines = 1, width, height }: { readonly lines?: number; readonly width?: string; readonly height?: string }) {
  if (height !== undefined) return <span className={styles.block} style={{ inlineSize: width ?? "100%", blockSize: height }} aria-hidden="true" />;
  return (
    <span className={styles.lines} style={{ inlineSize: width ?? "100%" }} aria-hidden="true">
      {Array.from({ length: lines }, (_, index) => (
        <span key={index} className={styles.line} />
      ))}
    </span>
  );
}
